import { render, staticRenderFns } from "./Company2TableItemEdit.vue?vue&type=template&id=0b8adc30"
import script from "./Company2TableItemEdit.js?vue&type=script&lang=js&external"
export * from "./Company2TableItemEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports